<app-navbar title="IsTour" *ngIf="fullscreen !== 1">
	<div class="input-group me-4">
		<span class="input-group-text">Od:</span>
		<input type="date" class="form-control" name="dateFrom" [(ngModel)]="date.from" (change)="settingsChanged()" />
		<span class="input-group-text">Do:</span>
		<input type="date" class="form-control" name="dateTo" [(ngModel)]="date.to" (change)="settingsChanged()" />
	</div>
	<ng-select
		name="newTag"
		[(ngModel)]="product"
		[items]="products"
		placeholder="Produkt"
		bindLabel="name"
		bindValue="id"
		(change)="productChanged()"
		class="me-4"
	>
	</ng-select>
	<ng-select
		name="newTag"
		[(ngModel)]="roomType"
		[items]="roomTypes"
		placeholder="Rodzaj pokoju"
		bindLabel="name"
		bindValue="id"
		(change)="settingsChanged()"
		class="me-4"
	>
	</ng-select>
	<div class="btn btn-primary" (click)="fullscreenShow()">
		<i class="fas fa-expand-arrows-alt"></i>
	</div>
</app-navbar>

<table>
	<tr>
		<td *ngFor="let element of contingent">
			{{ element.day | date: 'yy MM' }}
		</td>
	</tr>
	<tr>
		<td *ngFor="let element of contingent" class="date">
			{{ element.day | date: 'dd' }}
		</td>
	</tr>
	<tr>
		<td *ngFor="let element of contingent" class="avaliable">
			{{ element.avaliable }}
		</td>
	</tr>
</table>
